/**
 * Storage operations API endpoints (Phase 14)
 */

import { fetchApi, fetchRawApi } from '../core';
import type { StorageStatusResponse } from '../types';

export function getStorageStatus(componentName: string = 'Unknown') {
  return fetchApi<StorageStatusResponse>('/storage/status', {}, componentName);
}

/**
 * Returns the raw storage report CSV text. The export is audited server-side.
 * Uses fetchRawApi (not fetchApi) because the response is text/csv, not JSON.
 */
export async function exportReportCsv(
  componentName: string = 'Unknown'
): Promise<string> {
  const response = await fetchRawApi('/storage/report', { method: 'GET' }, componentName);
  if (!response.ok) {
    let message = `Export failed (${response.status})`;
    try {
      const body = await response.json();
      if (body && typeof body.error === 'string') message = body.error;
    } catch {
      /* swallow */
    }
    throw new Error(`[${componentName}] ${message}`);
  }
  return response.text();
}
